var _addEventListener;
var _messageEvent;
var _onMessage;

if (typeof window !== 'undefined') {
    const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    _addEventListener = window[eventMethod];
    _messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

    _onMessage = callback => {
        addEventListener(messageEvent, e => {
            if (callback != null) callback(e);
        });
    };
} else {
    _addEventListener = () => null;
    _messageEvent = null;
    _onMessage = () => null;
}

export const addEventListener = _addEventListener;
export const messageEvent = _messageEvent;
export default _onMessage;



// WEBPACK FOOTER //
// ./src/utils/iframeCommunication.js